module.exports = __webpack_public_path__ + "img/product-variants-example.d3f45a0d.svg";